import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import { queryKeys } from '@/api/queryKeys'
import type { components } from '@/../types/api'

export type Me = components['schemas']['MeOut']

/**
 * Quem está logado, do ponto de vista do backend. A UI usa ``is_admin`` para
 * esconder o que é do operador (notificações, navegador CDP, celular, teste do
 * Ollama), que desde 15/10/2026 responde 403 para os outros. Esconder é só
 * conforto: quem barra de verdade é o backend.
 */
export function useMe() {
  return useQuery({
    queryKey: queryKeys.me(),
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/me')
      if (!data) throw new Error('me empty')
      return data.data
    },
    staleTime: 5 * 60_000,
  })
}

/** ``true`` só quando o backend confirmou o admin; carregando ou erro contam como não-admin. */
export function useIsAdmin(): boolean {
  return useMe().data?.is_admin === true
}
